import { Box, Flex, Text, useBreakpointValue } from '@chakra-ui/react'
import _ from 'lodash'
import { ItList, ItListItem } from 'types/graphql'

import { BrandColor } from 'src/types'

import { BuyOptions } from '../..'

import Explain from './Explain/Explain'
import FreeItListInside from './FreeItListInside/FreeItListInside'
import { Statistic } from './getItListItemsCountByType'
import PaywalledItListInside from './PaywalledItListInside/PaywalledItListInside'
import useInside from './useInside'

export type InsideItemProps = {
  label: string
  plural: string
  icon: JSX.Element
  description({
    description,
    count,
    creatorName,
    creatorNamePossessive,
  }: {
    description: string
    count: number
    creatorName: string
    creatorNamePossessive: string
  }): string
}

export type InsideItems = {
  [index in Statistic | 'other']: InsideItemProps
}

const Inside: React.FC<{
  brandColor: BrandColor
  itList: ItList
  itListItems: ItListItem[]
  buy(options?: BuyOptions): unknown
  buyIsLoading: boolean
  isPreview: boolean
  withEmailPaywall: boolean
  locked: boolean
}> = ({
  brandColor,
  itList,
  itListItems,
  buy,
  buyIsLoading,
  isPreview,
  withEmailPaywall,
  locked,
}) => {
  const creatorName = itList.creator.firstName
  const { uiData, creatorNamePossessive, isPaywalled, currentInside } =
    useInside({
      brandColor,
      itList,
      itListItems,
      withEmailPaywall,
    })
  let isSmMd = useBreakpointValue({ sm: true, lg: false })
  if (isSmMd === undefined || !currentInside || !locked || !itListItems?.length)
    return null
  isSmMd = isSmMd || isPreview

  return (
    <Box mt={6} w="full" px={{ base: 4, lg: isPreview ? 4 : 24 }}>
      {isSmMd && (
        <Explain brandColor={brandColor} variant="brandColor" mt={10} mb={12} />
      )}
      <Flex mb={4} alignItems="center">
        <Box flexGrow={1}>
          <Box as="h4" className="thick">
            Inside
          </Box>
          <Text className="body-extra-small" color="graphite">
            Unlock {creatorNamePossessive} curated guide.
          </Text>
        </Box>
        {!isSmMd && <Explain brandColor={brandColor} variant="white" />}
      </Flex>
      {!!isPaywalled && (
        <PaywalledItListInside
          currentInside={currentInside}
          uiData={uiData}
          creatorName={creatorName}
          creatorNamePossessive={creatorNamePossessive}
          brandColor={brandColor}
          buyIsLoading={buyIsLoading}
          price={itList.price}
          withEmailPaywall={withEmailPaywall}
          buy={buy}
        />
      )}
      {!isPaywalled && (
        <FreeItListInside
          currentInside={currentInside}
          uiData={uiData}
          brandColor={brandColor}
          onClick={buy}
          isPreview={isPreview}
        />
      )}
    </Box>
  )
}

export default Inside
